import React, { useState, useEffect } from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import Container from "../Container"
import { Row, Input, List, Col, Affix, Drawer, Button } from "antd"
import { Search, Burger } from "../Icon"
import useFether from "../../hooks/useFetcher"
import "./MainNav.less"
import MenuDesktop from "./MenuDesktop"
import MenuMobile from "./MenuMobile"
import { useI18next } from "gatsby-plugin-react-i18next"

function MainNav() {
  const { t } = useI18next()
  const [state, setState] = useState(false)
  const [keyword, setKeyword] = useState("")
  const [offset, setOffset] = useState(0)
  const [showSearch, setShowSearch] = useState(false)
  const [showResult, setShowResult] = useState(false)
  const { data, loading } = useFether(keyword ? "/search?s=" + keyword : null, {
    result_data: [],
  })

  const { settings } = useStaticQuery(graphql`
    query LogoQuery {
      settings {
        logo {
          logo
        }
      }
    }
  `)

  const showDrawer = () => {
    setState(true)
  }

  const onClose = () => {
    setState(false)
  }

  const onSearch = e => {
    setShowResult(true)
    setKeyword(e)
    setOffset(document.querySelectorAll(".header")[0].offsetTop)
  }

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.overflow = showSearch
      ? "hidden"
      : "auto"
  }, [showSearch])

  return (
    <>
      <header>
        <Affix offsetTop={0}>
          <nav className="header">
            <Container>
              <Row justify="space-between" align="middle">
                <Col flex="none">
                  <Link to="/">
                    <img
                      src={settings.logo.logo || '/static/logo@2x-e686088c12e6cc6e4e87c4302633cb62.png'}
                      alt="LPDP"
                      width={123}
                      height="auto"
                      className="logo"
                    />
                  </Link>
                </Col>
                <Col flex="auto" className="hide-mobile">
                  <MenuDesktop setShowSearch={setShowSearch} />
                </Col>
                <Col flex="none" className="show-mobile">
                  <Button
                    onClick={() => setShowSearch(true)}
                    type="link"
                    style={{ marginRight: 15 }}
                  >
                    <Search style={{ fontSize: "22px" }} />
                  </Button>
                  <Button onClick={showDrawer} type="link">
                    <Burger style={{ fontSize: "24px" }} />
                  </Button>
                </Col>
              </Row>
            </Container>
            {showSearch && (
              <div className="search-container">
                <Container>
                  <Input.Search
                    autoFocus
                    onSearch={onSearch}
                    placeholder={t('Cari di sini...')}
                    prefix={
                      <div
                        onClick={() => {
                          setShowResult(false)
                          setShowSearch(false)
                        }}
                        style={{
                          display: "flex",
                          cursor: "pointer",
                          marginRight: 15,
                        }}
                      >
                        <svg
                          width={14}
                          height={14}
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.4163 1.876L12.1238 0.583496L6.99968 5.70766L1.87551 0.583496L0.583008 1.876L5.70718 7.00016L0.583008 12.1243L1.87551 13.4168L6.99968 8.29266L12.1238 13.4168L13.4163 12.1243L8.29218 7.00016L13.4163 1.876Z"
                            fill="#444444"
                          />
                        </svg>
                      </div>
                    }
                  />
                </Container>
              </div>
            )}
          </nav>
          {showResult && (
            <div className="search-result" style={{ top: offset + 60 }}>
              <Container>
                <hr
                  style={{
                    margin: "15px 0px 30px 0px",
                    backgroundColor: "#f0f0f0",
                  }}
                />
                <List
                  itemLayout="horizontal"
                  style={{
                    overflow: "auto",
                    maxHeight: "calc(100vh - 180px)",
                    paddingRight: 15,
                    marginRight: -15,
                  }}
                  loading={loading}
                  dataSource={data.result_data}
                  renderItem={item => (
                    <List.Item
                      actions={[
                        <Link to={item.url}>
                          <svg
                            width={13}
                            height={13}
                            viewBox="0 0 13 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4.49967 0.166504V1.83317H9.99134L0.333008 11.4915L1.50801 12.6665L11.1663 3.00817V8.49984H12.833V0.166504H4.49967Z"
                              fill="#FF6900"
                            />
                          </svg>
                        </Link>,
                      ]}
                    >
                      <List.Item.Meta
                        title={<a href="#">{item.title}</a>}
                        description={
                          <div
                            dangerouslySetInnerHTML={{ __html: item.excerpt }}
                          />
                        }
                      />
                    </List.Item>
                  )}
                />
              </Container>
            </div>
          )}
        </Affix>
      </header>
      {showSearch && <div className="search-container-backdrop" />}
      <Drawer
        placement="top"
        closable={false}
        onClose={onClose}
        visible={state}
        getContainer={false}
        style={{ position: "fixed" }}
        height="100%"
        className="mobile-drawer"
      >
        <MenuMobile closeMenu={onClose} />
      </Drawer>
    </>
  )
}

export default MainNav
